import { render, staticRenderFns } from "./IndicationTemp.vue?vue&type=template&id=3a4b36ff&scoped=true"
import script from "./IndicationTemp.vue?vue&type=script&lang=js"
export * from "./IndicationTemp.vue?vue&type=script&lang=js"
import style0 from "./IndicationTemp.vue?vue&type=style&index=0&id=3a4b36ff&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3a4b36ff",
  null
  
)

export default component.exports